module.exports = __webpack_public_path__ + "static/media/copy.4b71e474.svg";